<section class="searchresult-splash">
  <div class="content">
    <h1>Which vessel would you like to track?</h1>
    <div class="container">
      <div class="search-section">
        <form [formGroup]="portForm" class="search-section-right" (ngSubmit)="searchSchedules()">
          <div class="select-sec select-date-sec">
            <label></label>
            <div class="select-section-relative input-section">
              <p-calendar formControlName="date" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy" (onBlur)="reset('5')" [minDate]="minimumDate"
                [maxDate]="minDate">
              </p-calendar>
            </div>
          </div>
          <div class="select-sec revert-arrow">
          </div>
          <div class="select-sec">
            <div class="select-section-relative">
              <div class="input-section pRel">
                <p-dropdown formControlName="shippingLineId" [options]="shippinglineslist" optionLabel="companyName"
                  [filter]="true" filterMatchMode="startsWith" placeholder="Select Shippingline"
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onShippinglineChange($event)">
                </p-dropdown>
              </div>
            </div>
            <div class="select-section-relative">
              <div class=" pRel">
                <p-dropdown formControlName="vesselId" [options]="vesselslist" optionLabel="vesselsName" [filter]="true"
                  filterMatchMode="startsWith" placeholder="Select Vessel" 
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onVesselChange($event)">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="select-sec revert-arrow">
          </div>
          <div class="select-sec">
            <div class="select-section-relative">            
              <div class="input-section pRel">
                <p-dropdown formControlName="departurePort" [options]="departurePorts" optionLabel="label"
                [filter]="true" filterMatchMode="startsWith" placeholder="Select Departure Port" 
                [itemSize]="31" [virtualScroll]="true" (onChange)="onDeparturePortChange($event)">
              </p-dropdown>
               
              </div>
            </div>
            <div class="select-section-relative">
              <div class=" pRel">
                <p-dropdown formControlName="arrivalPort" [options]="arrivalPorts" optionLabel="label"
                  [filter]="true" filterMatchMode="startsWith" placeholder="Select Arrival Port"
                  [itemSize]="31" [virtualScroll]="true">
                </p-dropdown>                
              </div>
            </div>
          </div>
          
          <div class="select-sec select-date-sec">
            <label></label>
            <div class="select-section-relative input-section">
              <h2 style="color:white"><b>OR</b></h2>
            </div>
          </div>
          <div class="select-sec select-date-sec">
            <label></label>
            <div class="select-section-relative input-section">
              <input id="disabled-input" type="text" pInputText formControlName="trackNumber"
                placeholder="Enter Track Number" />
            </div>
          </div>
          <div class="btn-go-sec">
            <button pButton type="submit" label="Submit"
              class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<section class="bg-image-splash">

</section>